module.exports = __webpack_public_path__ + "static/media/lock.1f3507f0.svg";